import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UserInfo } from './../../../security/models/user-info';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SecurityService } from '../../../security/services/security.service';
import { User } from 'src/app/security/models/user';
import { RoutingService } from 'src/app/security/services/routing.service';
import { SecurityHelperService } from 'src/app/security/services/security-helper.service';
import { Authentication } from '../../../security/models';
import { StringHelper } from 'src/app/helpers';
import { ContractEntityService, PermissionService, SubjectObligedService } from 'src/app/services';
import { SubjectObligedBasic } from '../../../models/subject-obliged';
import { VulnerableActivityEnum } from 'src/app/enums';
import { AuthenticationResponse } from 'src/app/models';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  user: User = new User();
  formTouched = false;
  formSubmitted = false;
  showLoginError = false;
  show2FAInput = false;
  // hasActiveSession: boolean = false;
  rememberMe: boolean = false;
  userInfo: UserInfo = new UserInfo();
  loading: boolean = true;
  isAgent;
  isExternal = false;

  showingOfficeSubjectObgligeds: boolean;
  subjectObligeds: Array<SubjectObligedBasic> = new Array<SubjectObligedBasic>();

  constructor(
    private securityService: SecurityService,
    private routingService: RoutingService,
    private securityHelperService: SecurityHelperService,
    private activatedRoute: ActivatedRoute,
    private contractEntityService: ContractEntityService,
    private subjectObligedService: SubjectObligedService,
    private permissionService: PermissionService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject('IMAGES_URL') public imagesUrl: string
  ) {}

  getImage = () => "url('assets/images/texture-1.png')";

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const userToken = this.activatedRoute.snapshot.queryParamMap.get('token');
      const subjectId = +this.activatedRoute.snapshot.queryParamMap.get('subjectId');
      const contractId = +this.activatedRoute.snapshot.queryParamMap.get('contractId');
      const contractType = this.activatedRoute.snapshot.queryParamMap.get('requestType');

      // Comprobamos si existe un token
      if (!StringHelper.isNullOrEmpty(userToken) && !isNaN(contractId) && !isNaN(subjectId)) {
        // Establecemos el token y verificamos si es válido.
        this.setSessionUserInfo(userToken, subjectId, false);
        this.securityService
          .isLoggedIn()
          .toPromise()
          .then(() => {
            this.loginSOUser(subjectId, null, (user) => {
              this.isExternal = true;
              if(contractType === "billing" || contractType === "output" || contractType === "delete")
                this.routingService.navigateToContractPermissionApproval(contractId, contractType, this.activatedRoute);
              else
                this.routingService.navigateToContractSummaryDetail(contractId, this.activatedRoute);
            });
          });
      } else {
        // Verificamos si podemos iniciar sesión con el token persistido
        if (this.securityHelperService.token && this.securityHelperService.rememberMe) {
          // if (this.securityHelperService.rememberMe) {
          this.loginSOUser();
          // this.routingService.navigateHome();
          // }
          // else this.loading = false;
        } else this.loading = false;
      }
    }
  }

  /** Inicia sesión del usuario con el Id del sujeto obligado proporcionado. */
  loginSOUser(subjectObligedId?: number, branchOfficeId?: number | null, onSuccess?: (user: UserInfo) => void) {

    this.securityService.getUserInfo().toPromise().then((res: UserInfo) => {
        // Guardamos el código para iniciar sesión como sujecto obligado.

        const logAsSubject = (id: number) => {
          this.securityService
            .loginAsSubjectObliged(id, branchOfficeId)
            .toPromise()
            .then((soRes: AuthenticationResponse) => {
              this.setSessionUserInfo(soRes.token, id, true);
              // Obtenemos los permisos del usuario.
              this.permissionService.getPermissions().subscribe(
                (permissions) => {
                  this.securityHelperService.permissions = permissions;
                
                  // this.hasActiveSession = true;
                  // this.userInfo = res;
                  this.loading = false;

                  if (onSuccess !== undefined) {
                    onSuccess(res);
                    if (id && !this.isExternal) {
                      this.routingService.navigateHome();
                    }
                  } else if (id && soRes) {
                    this.routingService.navigateHome();
                  } else this.routingService.navigateToLoginPage();
                },
                (err) => {
                  this.routingService.navigateHome();
                }
              );
            });
        };

        // Si se ha proporcionado un id de sujeto obligado, iniciamos sesión con él.
        if (subjectObligedId !== undefined && subjectObligedId !== null && !isNaN(subjectObligedId)) {
          logAsSubject(subjectObligedId);
        } else {
          // En caso contrario lo obtenemos a partir del usuario.
          this.contractEntityService
            .getUserDataVeh()
            .toPromise()
            .then((userVeh) => logAsSubject(userVeh.subjectObligedId))
            .catch(error => {
              this.loading = false;
              this.showingOfficeSubjectObgligeds = false
            });
        }
      })
      .catch((err) => {
        // this.hasActiveSession = false;
        this.showingOfficeSubjectObgligeds = false;
        this.loading = false;
      });
  }
  back() {}

  logout() {
    this.securityService.signOut();
    this.showingOfficeSubjectObgligeds = false;
    // this.hasActiveSession = false;
  }

  onSubmit(isValid: any): void {
    if (!isValid) {
      this.formTouched = true;
      return;
    }

    this.formSubmitted = true;
    this.isDisabledUser = false;
    this.showLoginError = false;
    this.securityService.authenticate(this.user).subscribe(this.authenticationSucceeded, this.authenticationFailed);
  }

  private authenticationSucceeded = (authenticationResponse: AuthenticationResponse): void => {

    if(authenticationResponse.needsTwoFactorCode) {
      this.show2FAInput = true;
      this.formSubmitted = false;
    } else {
      this.securityHelperService.token = authenticationResponse.token;
      this.router.navigate(['/select']);
    }
  };

  isDisabledUser: boolean = false;

  private authenticationFailed = (error: any): void => {
    // this.loading = false;
    if (error && error.error && error.error.status && error.error.status == 401) {
      this.isDisabledUser = true;
    } else {
      this.showLoginError = true;
    }
    this.formTouched = false;
    this.formSubmitted = false;
  };

  /** Persiste la sesión del usuario. */
  private setSessionUserInfo(token: string, subjectObligedId: number, rememberMe: boolean) {
    this.securityHelperService.token = token;
    this.securityHelperService.subjectObligedId = subjectObligedId;
    this.securityHelperService.rememberMe = rememberMe;
  }
}
